import { HIDE_MODAL, SHOW_MODAL } from './action-types';
import { ModalName } from '../../types/ModalNames';

export const showModal = (modalName: ModalName, modalParams = {}) => {
  return {
    type: SHOW_MODAL,
    modalName,
    modalParams
  };
};

export const hideModal = () => ({
  type: HIDE_MODAL,
});
